import data from "../../../../../src/Link.docs.json";
import * as React from 'react';
export default {
  data,
  React
};